/**
 * Color tranformation
 * @param {?} intInput
 * @return {?}
 */
function getHexValue(intInput) {
    var /** @type {?} */ result = intInput.toString(16);
    if (result.length < 2) {
        result = '0' + result;
    }
    return result;
}
/**
 * @param {?} red
 * @param {?} green
 * @param {?} blue
 * @param {?=} alpha
 * @return {?}
 */
export function Color(red, green, blue, alpha) {
    return {
        red: red,
        green: green,
        blue: blue,
        alpha: alpha,
        toHex: function () {
            return getHexValue(red) + getHexValue(green) + getHexValue(blue);
        }
    };
}
;
// Converter which actually does the calculation from rgba to hex.
var /** @type {?} */ colorConverter = {
    // Converts the given color to a Color object, using the given gbColor in the calculation.
    convertToHex: function (color, bgColor) {
        var /** @type {?} */ alpha = color.alpha;
        /**
         * @param {?} tint
         * @param {?} bgTint
         * @return {?}
         */
        function getTintValue(tint, bgTint) {
            var /** @type {?} */ tmp = Math.floor((1 - alpha) * bgTint + alpha * tint);
            if (tmp > 255) {
                return 255;
            }
            return tmp;
        }
        return Color(getTintValue(color.red, bgColor.red), getTintValue(color.green, bgColor.green), getTintValue(color.blue, bgColor.blue));
    }
};
/**
 * @param {?} p
 * @param {?} q
 * @param {?} t
 * @return {?}
 */
function hue2rgb(p, q, t) {
    if (t < 0) {
        t += 1;
    }
    ;
    if (t > 1) {
        t -= 1;
    }
    ;
    if (t < 1 / 6) {
        return p + (q - p) * 6 * t;
    }
    ;
    if (t < 1 / 2) {
        return q;
    }
    ;
    if (t < 2 / 3) {
        return p + (q - p) * (2 / 3 - t) * 6;
    }
    ;
    return p;
}
var /** @type {?} */ colorStringParser = {
    // Converter for rgb(a) colors
    rgba: function (rgba) {
        // Strip the rgba-definition off the string.
        rgba = rgba.replace('rgba(', '')
            .replace(')', '')
            .replace(' ', '');
        // Split the rgba string into an array.
        var /** @type {?} */ splittedRgba = rgba.split(',');
        return Color(parseInt(splittedRgba[0], 10), parseInt(splittedRgba[1], 10), parseInt(splittedRgba[2], 10), parseFloat(splittedRgba[3]) || 1);
    },
    // Converter for hex colors
    hex: function (hexString) {
        hexString = hexString.replace('#', '');
        var /** @type {?} */ rgbArr = [], /** @type {?} */ hexPair;
        /**
         * @param {?} index
         * @return {?}
         */
        function getHexPartByIndex(index) {
            switch (hexString.length) {
                case 3:
                    return hexString[index] + hexString[index];
                default:
                    index *= 2;
                    return hexString[index] + hexString[index + 1];
            }
        }
        // String the "#" off the hex-string.
        hexString = hexString.replace('#', '');
        // Convert pairs of hex-characters into decimal numbers.
        for (var /** @type {?} */ i = 0; i < hexString.length; i++) {
            rgbArr.push(parseInt(getHexPartByIndex(i), 16));
        }
        return Color(rgbArr[0], rgbArr[1], rgbArr[2], 1);
    },
    // Converter for hsl(a) colors.
    hsla: function hslToRgb(hsla) {
        hsla = hsla.replace('hsla(', '')
            .replace('hsl(', '')
            .replace(')', '')
            .replace(' ', '');
        // Split the hsla string into an array.
        hsla = hsla.split(',');
        var /** @type {?} */ h = parseInt(hsla[0], 10) / 360;
        var /** @type {?} */ s = parseInt(hsla[1], 10) / 100;
        var /** @type {?} */ l = parseInt(hsla[2], 10) / 100;
        var /** @type {?} */ a = parseFloat(hsla[3]) || 1;
        var /** @type {?} */ r, /** @type {?} */ g, /** @type {?} */ b;
        if (s == 0) {
            r = g = b = l; // achromatic
        }
        else {
            var /** @type {?} */ q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var /** @type {?} */ p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return Color(Math.round(r * 255), Math.round(g * 255), Math.round(b * 255), a);
    }
};
/**
 * @param {?} colorString
 * @return {?}
 */
function getColorType(colorString) {
    if (colorString.indexOf('rgba') !== -1 || colorString.indexOf('rgb') !== -1) {
        return 'rgba';
    }
    if (colorString.indexOf('hsla') !== -1 || colorString.indexOf('hsl') !== -1) {
        return 'hsla';
    }
    return 'hex';
}
/**
 * @param {?} inputString
 * @return {?}
 */
function getColorForString(inputString) {
    return colorStringParser[getColorType(inputString)](inputString);
}
/**
 * @param {?} str
 * @return {?}
 */
export function trim(str) {
    return str.replace(/^\s+|\s+$/gm, '');
}
/**
 * @param {?} rgba
 * @return {?}
 */
export function rgbaToHex(rgba) {
    var /** @type {?} */ parts = rgba.substring(rgba.indexOf('(')).split(','), /** @type {?} */ r = parseInt(trim(parts[0].substring(1)), 10), /** @type {?} */ g = parseInt(trim(parts[1]), 10), /** @type {?} */ b = parseInt(trim(parts[2]), 10), /** @type {?} */ a = parseFloat(trim(parts[3].substring(0, parts[3].length - 1))).toFixed(2);
    return ('#' + r.toString(16) + g.toString(16) + b.toString(16) + (Number(a) * 255).toString(16).substring(0, 2));
}
/**
 * @param {?} c
 * @return {?}
 */
export function componentToHex(c) {
    c = Number(c);
    var /** @type {?} */ hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}
/**
 * @param {?} str
 * @param {?=} alpha
 * @return {?}
 */
export function toRgb(str, alpha) {
    return hexToRgba(colorConverter.convertToHex(getColorForString(str), getColorForString('#ffffff')).toHex(), alpha || 1);
}
/**
 * @param {?} rgb
 * @return {?}
 */
export function rgbToHex(rgb) {
    var /** @type {?} */ toRgb = rgb;
    if (toRgb.substr(0, 4) === 'rgba') {
        toRgb = toRgb.slice(5);
    }
    else {
        toRgb = toRgb.slice(4);
    }
    toRgb = toRgb.slice(0, -1);
    toRgb = toRgb.replace(' ', '');
    toRgb = toRgb.split(',');
    return componentToHex(toRgb[0]) + componentToHex(toRgb[1]) + componentToHex(toRgb[2]);
}
/**
 * @param {?} rgba
 * @return {?}
 */
export function rgbTransparent(rgba) {
    if (typeof rgba === 'string') {
        rgba = rgba.slice(0, -1);
        rgba = (rgba.split(',')[3]) * 1;
        if (typeof rgba === 'number') {
            rgba = 1;
        }
    }
    else {
        rgba = 1;
    }
    return rgba;
}
/**
 * @param {?} hex
 * @param {?=} tr
 * @return {?}
 */
export function hexToRgba(hex, tr) {
    if (tr === void 0) { tr = -1; }
    var /** @type {?} */ _default = hex;
    var /** @type {?} */ transparent = {
        r: 0,
        g: 0,
        b: 0,
        a: 0
    };
    if (tr === -1) {
        tr = rgbTransparent(hex);
    }
    hex = String(hex);
    if ((hex.substr(0, 4) === 'rgba') && !!hex.split(',')[3]) {
        tr = parseFloat(hex.split(',')[3].replace(')', ''));
        hex = String(hex);
        if (hex.length !== 6 && hex.length !== 3) {
            hex = rgbToHex(hex);
        }
        console.log('%cHEX', 'color:purple;', JSON.stringify(hex, null, 2));
    }
    if (hex !== undefined && hex !== null && hex !== 'transparent') {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var /** @type {?} */ shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });
        var /** @type {?} */ result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        var /** @type {?} */ colorr = 0;
        var /** @type {?} */ colorg = 0;
        var /** @type {?} */ colorb = 0;
        if (result) {
            colorr = parseInt(result[1], 16);
            colorg = parseInt(result[2], 16);
            colorb = parseInt(result[3], 16);
        }
        return result ? {
            json: {
                r: colorr,
                g: colorg,
                b: colorb,
                a: tr
            },
            color: "rgba(" + colorr + ", " + colorg + ", " + colorb + ", " + tr + ")",
        } : {
            json: transparent,
            color: "" + _default,
        };
    }
    else {
        return {
            json: transparent,
            color: "rgba(" + 0 + ", " + 0 + ", " + 0 + ", " + 0 + ")",
        };
    }
}
// console.log(hexToRgba('purple'), 'purple');
// console.log(hexToRgba('string'), 'string');
// console.log(hexToRgba('#000'), '#000');
// console.log(toRgb('rgba(0, 0, 0, 0.6)'), 'rgba(0, 0, 0, 0.6)');
// console.log(rgbaToHex('rgba(0, 0, 0, 0.6)'), 'rgba(0, 0, 0, 0.6)');
// console.log(hexToRgba('rgb(0, 0, 0)'), 'rgb(0, 0, 0)');
// console.log(hexToRgba('rgba(0, 0, 0, 0.6)'), 'rgba(0, 0, 0, 0.6)');
// console.log(hexToRgba('rgba(25, 5, 10, 54)'), 'rgba(255, 255, 10, 0.54)');
// console.log(hexToRgba('rgba(255, 55, 10, 0.54321)'), 'rgba(255, 255, 10, 0.54321)');
// console.log(hexToRgba('rgba(255, 255, 10)'), 'rgba(255, 255, 10)');
// console.log(hexToRgba('#000'), '#000');
// console.log(hexToRgba('#000', .69), '#000, .69');
// console.log(hexToRgba('#00bcd4'), '#00bcd4');
// console.log(hexToRgba('#000999'), '#00bcd4');
/*
npm run tsc ./src/lib/core/colorTranformation.ts
node ./src/lib/core/colorTranformation.js

*/



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/core/color-tranformation.js
// module id = 693
// module chunks = 31